import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  UploadOutlined,
  SettingOutlined,
  DownOutlined,
  MoreOutlined,
  MinusOutlined,
  PlusOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  YoutubeOutlined,
  EditOutlined,
  CloseOutlined,
  LeftOutlined,
  FileFilled,
  FilePptFilled,
  FilePdfFilled,
  FileWordFilled,
} from "@ant-design/icons";
import { Dropdown, Modal, message } from "antd";
import { ReactComponent as FileUploadIcon } from "../../../assets/Icons/upload.svg";
import { ReactComponent as Tick } from "../../../assets/Icons/tick.svg";
import { useSelector } from "react-redux";
import PostUpdateData from "../../../hooks/postUpdate";
import FetchData from "../../../hooks/FetchData";
import vectorimage from "../../../assets/Vector.svg";  

const CreateCourseWrap = styled.div`
  padding: 20px;
  font-family: "DM Sans", sans-serif;

  .breadcrumb {
    font-family: "DM Sans", sans-serif;
    display: flex;
    font-size: 16px;

    a {
      color: #636980;
      text-decoration: none;
    }

    .separator {
      margin: 0 5px;
      color: #636980;
    }
  }

  .user-menu-title {
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #636980;
    cursor: pointer;
  }

  .course-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .course-header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .course-settings-link {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    color: #1f243b;
    /* font-size: 14px; */
    cursor: pointer;
    padding: 0;
      color: #1F243B;
  font-family: "DM Sans", sans-serif;  
  font-size: 16px;                    
  font-weight: 400; 
  }

  .publish-course-button {
    background: #C2FAE5;
    padding: 8px 16px;
    font-family: "DM Sans", sans-serif;
  font-size: 16px;                      /* was 14px */
  font-weight: 400;
      width: 170px;
    height: 34px;
    border-radius: 8px;
    border: 0.5px solid transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #1F243B;
  }

  .content-wrapper {
    display: flex;
    background-color: #ffffff;
    border-top: 1px solid #e0e0e0;
    box-sizing: border-box;
  }

  .side-menu {
    position: relative;
    width: 228.64px;
    min-height: 400px;
    border-right: 1px solid #e0e0e0;
    background: #ffffff;
    padding: 16px 16px 0px 0px;
    flex-shrink: 0;

    .add-units-select {
      position: relative;
      width: 216px;
      margin-bottom: 16px;

      /* Figma's chevron instead of the browser's native select arrow. */
      .add-units-chevron {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 11px;
        color: #1F243B;
        pointer-events: none;
      }
    }

    select {
      width: 216px;
      height: 34px;
      padding: 6px 32px 6px 8px;
      font-family: "DM Sans", sans-serif;
      font-size: 14px;
      border: 1px solid #1F243B;
      border-radius: 8px;
      background: #ffffff;
      color: #1F243B;
      appearance: none;
      -webkit-appearance: none;
      cursor: pointer;
    }

    .separator-line {
      width: 216px;
      height: 1px;
      border-top: 1px solid #E2E2E8;
      margin-bottom: 10px;
    }

    ul {
      list-style: none;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 6px;

      .unit-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 10px;
        font-size: 14px;
        cursor: pointer;
        background: #E2E2E8;
        width: 196px;
        min-height: 38px;
        gap: 8px;
        border-radius: 8px;
        transition: background 0.2s ease;

        &.active {
          background: #C2FAE5;
        }

        &:hover {
          background: #d3f6e9;
        }
      }

      .unit-item-label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }

      .unit-item-menu {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        border: none;
        background: transparent;
        padding: 0;
        cursor: pointer;
        color: #1F243B;
        font-size: 16px;
        visibility: hidden;
      }

      /* Figma shows the menu on the selected unit; hover/focus reveal it
         on the others so they stay reachable. */
      .unit-item.active .unit-item-menu,
      .unit-item:hover .unit-item-menu,
      .unit-item-menu:focus-visible,
      .unit-item-menu.ant-dropdown-open {
        visibility: visible;
        
      }
    }
  }

  .course-details {
    flex-grow: 1;
    padding: 16px;
    max-width: 1140px;

    .unit-title-input {
      width: 100%;
      font-family: "DM Sans", sans-serif;
      font-size: 20px;
      font-weight: 600;
      padding: 8px 0;
      border: none;
      border-bottom: 1px solid #E2E2E8;
      margin-bottom: 16px;
      color: #1F243B;
      background: transparent;
    }

    .field-label {
      font-family: "DM Sans", sans-serif;
      font-size: 14px;
      color: #636980;
      margin-bottom: 8px;
    }

    input[type="text"],
    textarea {
      width: 100%;
      font-family: "DM Sans", sans-serif;
      font-size: 14px;
      padding: 8px;
      border: 1px solid #D9D9D9;
      border-radius: 5px;
      margin-bottom: 0px;
      color: #1F243B;
    }

    textarea {
      resize: vertical;
      min-height: 88px;
    }

    .course-header-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 8px 16px;
      border-radius: 12px;
      background-color: #F3FEFA;
      min-height: 156px;
      gap: 16px;
    }

    .course-header-box input {
      flex: 1;
      font-family: "DM Sans", sans-serif;
      font-size: 24px;
      font-weight: 600;
      padding: 8px;
      border: none;
      background: transparent;
      color: #1F243B;
    }

    .upload-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 200px;
      min-width: 200px;
      height: 120px;
      gap: 8px;
      border-radius: 8px;
      border: 2px dashed #636980;
      background-color: #f3fefa;
      cursor: pointer;
    }

    .upload-section span {
      font-family: "DM Sans", sans-serif;
      font-size: 13px;
      text-align: center;
      color: #2D53DA !important;
    }

    .upload-section {
      position: relative;
      overflow: hidden;
    }

    .upload-section-label {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }

    /* Uploaded image fills the box; the "Change Course Profile" label
       sits on a dark scrim over it so it stays readable. */
    .upload-section.has-image {
      border-style: solid;
    }

    .upload-section-image {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .upload-section.has-image .upload-section-label {
      width: 100%;
      height: 100%;
      justify-content: center;
      background: rgba(31, 36, 59, 0.45);
      opacity: 0;
      transition: opacity 0.2s;
    }

    .upload-section.has-image:hover .upload-section-label,
    .upload-section.is-uploading .upload-section-label {
      opacity: 1;
    }

    .upload-section.has-image span {
      color: #fff !important;
    }

    .description-section {
      margin-top: 16px;
    }

    .rich-toolbar {
      display: flex;
      align-items: center;
      gap: 14px;
      background: #F4F4F4;
      border: 1px solid #D9D9D9;
      border-bottom: none;
      border-radius: 5px 5px 0 0;
      padding: 8px 12px;
      font-size: 13px;
      color: #636980;

      span {
        cursor: default;
        display: inline-flex;
        align-items: center;
      }

      .rt-size {
        padding: 0 8px;
        background: #ffffff;
        border-radius: 4px;
        color: #1F243B;
      }

      .rt-b { font-weight: 700; }
      .rt-u { text-decoration: underline; }
      .rt-i { font-style: italic; }
    }

    .rich-textarea {
      border-radius: 0 0 5px 5px;
      min-height: 220px;
    }

    .media-button-row {
      display: flex;
      gap: 16px;
      margin-top: 16px;
    }

    .media-choice-button {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 20px 16px;
      border-radius: 8px;
      background-color: #F4F4F4;
      color: #1F243B;
      cursor: pointer;
      border: none;
      font-family: "DM Sans", sans-serif;
      font-size: 14px;

      &:hover {
        background-color: #C2FAE5;
      }
    }

    .media-choice-button svg {
      width: 20px;
      height: 20px;
    }

    .media-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;

      .field-label {
        margin-bottom: 8px;
      }
    }

    .media-change {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      border: none;
      background: transparent;
      padding: 0;
      color: #1F243B;
      font-family: "DM Sans", sans-serif;
      font-size: 14px;
      cursor: pointer;
    }

    /* Figma: uploaded file shown as a grey row with a file-type icon. */
    .uploaded-file {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 12px;
      border-radius: 5px;
      background: #F4F4F4;
      color: #1F243B;
      font-size: 14px;

      .uploaded-file-name {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .uploaded-file-remove {
        border: none;
        background: transparent;
        color: #636980;
        cursor: pointer;
        padding: 0;
      }
    }

    .media-preview {
      margin-top: 16px;

      iframe,
      video {
        max-width: 100%;
        border-radius: 8px;
        background: #000;
      }
    }

    .web-content-preview {
      margin-top: 16px;
      padding: 16px;
      border: 1px solid #E2E2E8;
      border-radius: 8px;
      background: #FAFAFA;

      .preview-title {
        font-weight: 600;
        color: #1F243B;
        margin-bottom: 6px;
      }

      .preview-desc {
        color: #636980;
        font-size: 13px;
        margin-bottom: 10px;
      }

      a {
        color: #2D53DA;
        font-size: 13px;
        text-decoration: underline;
      }
    }
  }

  .add-units-container {
    margin-top: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .add-units-button {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 47px;
    height: 47px;
    border-radius: 50%;
    background: #E2E2E8;
    font-size: 22px;
    color: #636980;
  }

  /* Course Settings full-page view */
  .settings-back {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #636980;
    font-size: 14px;
    cursor: pointer;
    width: fit-content;
    margin-bottom: 16px;
  }

  .settings-heading {
    font-family: "DM Sans", sans-serif;
    font-size: 22px;
    font-weight: 600;
    color: #1F243B;
    margin-bottom: 20px;
  }

  .settings-tabs {
    display: flex;
    gap: 28px;
    border-bottom: 1px solid #E2E2E8;
    margin-bottom: 24px;

    span {
      padding-bottom: 10px;
      font-size: 14px;
      color: #636980;
      cursor: pointer;
      border-bottom: 2px solid transparent;

      &.active {
        color: #1F243B;
        font-weight: 500;
        border-bottom-color: #1F243B;
      }
    }
  }

  .settings-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 32px;
    padding-top: 16px;
    border-top: 1px solid #E2E2E8;
  }

  .settings-cancel-btn {
    padding: 8px 24px;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #1F243B;
    cursor: pointer;
    font-family: "DM Sans", sans-serif;
  }

  .settings-save-btn {
    padding: 8px 24px;
    border-radius: 8px;
    border: none;
    background: #C2FAE5;
    color: #1F243B;
    cursor: pointer;
    font-family: "DM Sans", sans-serif;
  }
`;

const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 32px;
  font-family: "DM Sans", sans-serif;
  max-width: 900px;

  .settings-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .settings-field.full-width {
    grid-column: 1 / -1;
  }

  .settings-field label {
    font-size: 13px;
    color: #636980;
  }

  .settings-field input,
  .settings-field select {
    height: 36px;
    padding: 6px 10px;
    font-size: 14px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    font-family: "DM Sans", sans-serif;
    color: #1F243B;
  }

  .settings-field.checkbox-field {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-top: 22px;
  }

  .settings-field.checkbox-field input {
    width: 16px;
    height: 16px;
    accent-color: #2ecc9a;
  }

  .settings-field.checkbox-field label {
    font-size: 14px;
    color: #1f243b;
  }

  .radio-row {
    display: flex;
    gap: 24px;
    margin-top: 4px;
  }

  .radio-option {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #1f243b;
  }

  .radio-option input {
    width: 16px;
    height: 16px;
    accent-color: #2ecc9a;
  }
`;

const SETTINGS_TABS = ["Course Details", "Availability", "Rules and Paths", "Certificate"];

// Figma only fully designed these five unit types (Content, Web Content,
// Video, Audio, Presentation/Document) — every other option in the dropdown
// loops back to the Content frame in the prototype, so there's no spec for
// them. They fall back to a plain title + description editor.
const UNIT_TYPES = [
  "Content",
  "Web content",
  "Video",
  "Audio",
  "Presentation / Document",
  "Iframe",
  "Test",
  "Survey",
  "Assignment",
  "Instructor Led Training",
  "Scorm",
];

const DESIGNED_UNIT_TYPES = ["Content", "Web content", "Video", "Audio", "Presentation / Document"];

const emptyUnitFields = {
  title: "",
  body: "",
  url: "",
  description: "",
  mediaUrl: "",
  mediaSource: "",
  showMediaInput: false,
};

const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};

// Uploads are stored as `course-media/<client>/<timestamp>-<safe name>`
// (see getVideoUploadUrl in the course handler), so the original name is
// the last path segment minus the timestamp prefix.
const fileNameFromUrl = (url) => {
  if (!url) return "";
  const lastSegment = decodeURIComponent(url.split("?")[0].split("/").pop() || "");
  return lastSegment.replace(/^\d+-/, "");
};

// Units saved before mediaSource existed: anything that isn't a YouTube
// link was an upload (links only exist for Video's "Add YouTube Video").
const isUploadedMedia = (unit) =>
  unit.mediaSource ? unit.mediaSource === "upload" : !!unit.mediaUrl && !getYouTubeEmbedUrl(unit.mediaUrl);

// Figma shows a coloured file-type icon in front of each uploaded file
// (green for video/audio, orange for slides).
const FILE_TYPE_ICONS = [
  { pattern: /\.(pptx?|key|odp)$/i, Icon: FilePptFilled, color: "#E4572E" },
  { pattern: /\.pdf$/i, Icon: FilePdfFilled, color: "#E5484D" },
  { pattern: /\.(docx?|odt|rtf)$/i, Icon: FileWordFilled, color: "#2B579A" },
  { pattern: /\.(mp4|mov|webm|mkv|avi|m4v|mp3|wav|m4a|aac|ogg|flac)$/i, Icon: FileFilled, color: "#12B76A" },
];

const FileTypeIcon = ({ name }) => {
  const match = FILE_TYPE_ICONS.find(({ pattern }) => pattern.test(name));
  const Icon = match?.Icon || FileFilled;
  return <Icon style={{ fontSize: 18, color: match?.color || "#636980" }} />;
};

const UploadedFileRow = ({ unit, onRemove }) => {
  const name = fileNameFromUrl(unit.mediaUrl);
  return (
    <div className="uploaded-file">
      <FileTypeIcon name={name} />
      <span className="uploaded-file-name">{name}</span>
      <button type="button" className="uploaded-file-remove" aria-label="Remove file" onClick={onRemove}>
        <CloseOutlined />
      </button>
    </div>
  );
};

const toDateInputValue = (value) => (value ? String(value).slice(0, 10) : "");
const toTimeInputValue = (value) => (value ? String(value).slice(0, 5) : "");

const buildDefaultSettings = (course) => ({
  course_code: course?.course_code || "",
  category: course?.category || "",
  price: course?.price || "",
  hide_courselist: !!course?.hide_courselist,
  conducted_by: course?.conducted_by || "",
  uploaded_on: toDateInputValue(course?.uploaded_on) || new Date().toISOString().slice(0, 10),
  area: course?.area || "",
  grade_attend: course?.grade_attend || "",
  delivery_type: course?.delivery_type || "",
  delivery: course?.delivery || "",
  access: course?.access || "",
  cpd_certified: !!course?.cpd_certified,
  country: course?.country || "",
  hours: course?.hours || "",
  certificate_level: course?.certificate_level || "",
  cpd_hours: course?.cpd_hours || "",
  capacity: course?.capacity || "",
  department: course?.department || "",
  location: course?.location || "",
  start_date: toDateInputValue(course?.start_date),
  end_date: toDateInputValue(course?.end_date),
  start_time: toTimeInputValue(course?.start_time),
  end_time: toTimeInputValue(course?.end_time),
  show_units: course?.show_units || "In any order",
  course_completed_when: course?.course_completed_when || "All the units are completed",
  calculate_score_by: course?.calculate_score_by || "All tests and assignments",
  offer_certificate: !!course?.offer_certificate,
});

const CreateCourse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editingCourse = location.state || null;
  const userInfo = useSelector((state) => state.authTracking.userInfo);
  const unitTypeSelectRef = useRef(null);
  const fileInputRef = useRef(null);
  const pendingUploadUnitIdRef = useRef(null);
  const [uploadingUnitId, setUploadingUnitId] = useState(null);

  const profileFileInputRef = useRef(null);
  const [courseProfileUrl, setCourseProfileUrl] = useState(editingCourse?.course_profile || null);
  const [uploadingProfile, setUploadingProfile] = useState(false);

  const [courseName, setCourseName] = useState(editingCourse?.course_name || "");
  const [description, setDescription] = useState(editingCourse?.course_describtion || "");
  const [saving, setSaving] = useState(false);

  const [units, setUnits] = useState(() =>
    Array.isArray(editingCourse?.units)
      ? editingCourse.units.map((unit, index) => ({
          ...emptyUnitFields,
          ...unit,
          id: unit?.id || `unit-${index}-${Date.now()}`,
          // showMediaInput is transient UI state stripped before saving, so
          // a saved unit with a mediaUrl needs it re-derived on load or the
          // editor would show the "choose a source" buttons over real data.
          showMediaInput: !!unit?.mediaUrl,
        }))
      : []
  );
  const [activeUnitId, setActiveUnitId] = useState(null);
  const [publishedVisible, setPublishedVisible] = useState(false);
  const unitTitleInputRef = useRef(null);

  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsTab, setSettingsTab] = useState("Course Details");
  const [settings, setSettings] = useState(() => buildDefaultSettings(editingCourse));
  const settingsSnapshotRef = useRef(null);

  // Settings > Course > Custom Field definitions - previously defined
  // there but never read anywhere else, so a field created there never
  // showed up here. Fetched once; values are keyed by field_id and sent
  // back as custom_fields on publish, same shape People's Add form uses.
  const [courseCustomFields, setCourseCustomFields] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState(() => {
    const initial = {};
    (editingCourse?.custom_values || []).forEach(({ field_id, value }) => {
      initial[field_id] = value;
    });
    return initial;
  });

  useEffect(() => {
    if (!userInfo?.clientId) return;
    FetchData({ endPoint: `/settings/getCourseList/${userInfo.clientId}` })
      .then((response) => {
        if (response?.statusCode === 200 && Array.isArray(response.response)) {
          setCourseCustomFields(
            response.response.map((item) => ({
              field_id: item.course_id,
              field_name: item.course_name,
              type: item.type,
              mandatory: item.mandatory,
              field_options: item.field_options,
            }))
          );
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.clientId]);

  const updateCustomFieldValue = (fieldId, value) => {
    setCustomFieldValues((prev) => ({ ...prev, [fieldId]: value }));
  };

  const activeUnit = units.find((unit) => unit.id === activeUnitId) || null;

  const updateSetting = (field, value) => {
    setSettings((prev) => ({ ...prev, [field]: value }));
  };

  const openSettings = () => {
    settingsSnapshotRef.current = settings;
    setSettingsTab("Course Details");
    setSettingsOpen(true);
  };

  const cancelSettings = () => {
    if (settingsSnapshotRef.current) setSettings(settingsSnapshotRef.current);
    setSettingsOpen(false);
  };

  const saveSettings = () => setSettingsOpen(false);

  const handleAddUnit = (type) => {
    if (!type) return;
    const newUnit = { id: `unit-${Date.now()}`, type, ...emptyUnitFields, title: type };
    setUnits((prev) => [...prev, newUnit]);
    setActiveUnitId(newUnit.id);
  };

  const updateUnitField = (id, field, value) => {
    setUnits((prev) => prev.map((unit) => (unit.id === id ? { ...unit, [field]: value } : unit)));
  };

  const revealUnitMedia = (id) => {
    updateUnitField(id, "mediaSource", "link");
    updateUnitField(id, "showMediaInput", true);
  };

  // Figma's "Change" (pencil) and remove (x) both drop the current media
  // and go back to the source buttons.
  const clearUnitMedia = (id) => {
    updateUnitField(id, "mediaUrl", "");
    updateUnitField(id, "mediaSource", "");
    updateUnitField(id, "showMediaInput", false);
  };

  const triggerFileUpload = (unitId) => {
    pendingUploadUnitIdRef.current = unitId;
    fileInputRef.current?.click();
  };

  const handleFileSelected = async (e) => {
    const file = e.target.files?.[0];
    const unitId = pendingUploadUnitIdRef.current;
    e.target.value = ""; // allow re-selecting the same file later
    if (!file || !unitId || !userInfo?.clientId) return;

    setUploadingUnitId(unitId);
    try {
      const urlResponse = await PostUpdateData({
        endPoint: `/course/getuploadurl/${userInfo.clientId}`,
        method: "POST",
        obj: { file_name: file.name, content_type: file.type },
      });
      const { uploadUrl, fileUrl } = urlResponse?.response || {};
      if (!uploadUrl || !fileUrl) {
        throw new Error("No upload URL returned");
      }

      // Upload straight to S3 with the presigned URL — this bypasses our
      // own API entirely, so it must not carry our tymeplusjwt auth header.
      const uploadResult = await fetch(uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": file.type || "application/octet-stream" },
        body: file,
      });
      if (!uploadResult.ok) {
        throw new Error(`S3 upload failed with status ${uploadResult.status}`);
      }

      updateUnitField(unitId, "mediaUrl", fileUrl);
      updateUnitField(unitId, "mediaSource", "upload");
      updateUnitField(unitId, "showMediaInput", true);
      message.success("File uploaded successfully");
    } catch (error) {
      console.error("Error uploading file:", error);
      message.error("Upload failed");
    } finally {
      setUploadingUnitId(null);
    }
  };

  const handleProfileFileSelected = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file || !userInfo?.clientId) return;

    setUploadingProfile(true);
    try {
      const urlResponse = await PostUpdateData({
        endPoint: `/course/getuploadurl/${userInfo.clientId}`,
        method: "POST",
        obj: { file_name: file.name, content_type: file.type },
      });
      const { uploadUrl, fileUrl } = urlResponse?.response || {};
      if (!uploadUrl || !fileUrl) {
        throw new Error("No upload URL returned");
      }

      const uploadResult = await fetch(uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": file.type || "application/octet-stream" },
        body: file,
      });
      if (!uploadResult.ok) {
        throw new Error(`S3 upload failed with status ${uploadResult.status}`);
      }

      setCourseProfileUrl(fileUrl);
      message.success("Course profile image uploaded successfully");
    } catch (error) {
      console.error("Error uploading course profile image:", error);
      message.error("Upload failed");
    } finally {
      setUploadingProfile(false);
    }
  };

  const handleDuplicateUnit = (id) => {
    const unit = units.find((item) => item.id === id);
    if (!unit) return;
    const copy = { ...unit, id: `unit-${Date.now()}`, title: unit.title ? `${unit.title} (copy)` : unit.title };
    setUnits((prev) => [...prev, copy]);
    setActiveUnitId(copy.id);
  };

  const handleDeleteUnit = (id) => {
    setUnits((prev) => prev.filter((unit) => unit.id !== id));
    setActiveUnitId((current) => (current === id ? null : current));
  };

  // A unit's name is its title input, so Rename just opens the unit with
  // that input focused and selected.
  const handleRenameUnit = (id) => {
    setActiveUnitId(id);
    setTimeout(() => {
      unitTitleInputRef.current?.focus();
      unitTitleInputRef.current?.select();
    }, 0);
  };

  const unitMenuItems = [
    { key: "rename", label: "Rename" },
    { key: "duplicate", label: "Duplicate" },
    { key: "delete", label: "Delete" },
  ];

  const handleUnitMenuClick = (unitId, key) => {
    if (key === "rename") handleRenameUnit(unitId);
    if (key === "duplicate") handleDuplicateUnit(unitId);
    if (key === "delete") handleDeleteUnit(unitId);
  };

  const handlePublish = async () => {
    if (!courseName.trim() || !settings.course_code.trim()) {
      message.error("Course name and course code are required");
      setSettingsOpen(false);
      return;
    }
    if (!userInfo?.clientId) {
      message.error("You must be logged in to save a course");
      return;
    }

    // `units` is a native Postgres array column (jsonb[]) — `pg` serializes
    // a raw JS array into Postgres array-literal syntax automatically, but
    // each *element* needs to already be a JSON string or Postgres can't
    // parse it as jsonb.
    const payload = {
      course_name: courseName,
      course_code: settings.course_code,
      category: settings.category,
      price: settings.price,
      course_describtion: description,
      course_profile: courseProfileUrl || null,
      // id used to be stripped here, so no unit ever kept a stable identity
      // across a save - editing a course regenerated a fresh id for every
      // unit every time (see the unit?.id fallback below, which existed for
      // exactly this - a persisted id to prefer over that fallback - but
      // never actually got one). Needed so anything that references a
      // specific unit (e.g. Scoring) has something stable to point at.
      units: units.map(({ showMediaInput, ...rest }) => JSON.stringify(rest)),
      updated_at: new Date().toISOString(),
      uploaded_on: settings.uploaded_on || null,
      conducted_by: settings.conducted_by || null,
      delivery_type: settings.delivery_type || null,
      delivery: settings.delivery || null,
      area: settings.area || null,
      grade_attend: settings.grade_attend || null,
      country: settings.country || null,
      hours: settings.hours || null,
      access: settings.access || null,
      cpd_certified: settings.cpd_certified,
      certificate_level: settings.certificate_level || null,
      cpd_hours: settings.cpd_hours || null,
      capacity: settings.capacity || null,
      department: settings.department || null,
      location: settings.location || null,
      start_date: settings.start_date || null,
      end_date: settings.end_date || null,
      start_time: settings.start_time || null,
      end_time: settings.end_time || null,
      show_units: settings.show_units,
      course_completed_when: settings.course_completed_when || null,
      calculate_score_by: settings.calculate_score_by || null,
      offer_certificate: settings.offer_certificate,
      hide_courselist: settings.hide_courselist,
      custom_fields: customFieldValues,
    };

    setSaving(true);
    try {
      const response = editingCourse?.course_id
        ? await PostUpdateData({
            endPoint: `/course/updatecourse/${userInfo.clientId}/${editingCourse.course_id}`,
            method: "PATCH",
            obj: { ...payload, created_at: editingCourse.created_at },
          })
        : await PostUpdateData({
            endPoint: `/course/addcourse/${userInfo.clientId}`,
            method: "POST",
            obj: payload,
          });

      if (response?.statusCode === 201 || response?.status === 200 || response?.statusCode === 200) {
        // Figma: centred "Published" confirmation with a green tick.
        setPublishedVisible(true);
        setTimeout(() => navigate("/course"), 1500);
      } else {
        message.error("Something went wrong while saving the course");
      }
    } catch (error) {
      console.error("Error saving course:", error);
      message.error("Something went wrong while saving the course");
    } finally {
      setSaving(false);
    }
  };

  if (settingsOpen) {
    return (
      <CreateCourseWrap>
        <div className="settings-back" onClick={cancelSettings}>
          <LeftOutlined style={{ fontSize: 11 }} /> Back
        </div>
        <h2 className="settings-heading">Course Settings</h2>
        <div className="settings-tabs">
          {SETTINGS_TABS.map((tab) => (
            <span
              key={tab}
              className={settingsTab === tab ? "active" : ""}
              onClick={() => setSettingsTab(tab)}
            >
              {tab}
            </span>
          ))}
        </div>

        {settingsTab === "Course Details" && (
          <SettingsGrid>
            <div className="settings-field">
              <label>Course Code</label>
              <input
                type="text"
                value={settings.course_code}
                onChange={(e) => updateSetting("course_code", e.target.value)}
              />
            </div>
            <div className="settings-field">
              <label>Category</label>
              <input
                type="text"
                value={settings.category}
                onChange={(e) => updateSetting("category", e.target.value)}
              />
            </div>

            <div className="settings-field">
              <label>Price ($)</label>
              <input
                type="text"
                value={settings.price}
                onChange={(e) => updateSetting("price", e.target.value)}
              />
            </div>
            <div className="settings-field checkbox-field">
              <input
                type="checkbox"
                id="hide_courselist"
                checked={settings.hide_courselist}
                onChange={(e) => updateSetting("hide_courselist", e.target.checked)}
              />
              <label htmlFor="hide_courselist">Hide from Course List</label>
            </div>

            <div className="settings-field">
              <label>Conducted by</label>
              <input
                type="text"
                value={settings.conducted_by}
                onChange={(e) => updateSetting("conducted_by", e.target.value)}
              />
            </div>
            <div className="settings-field">
              <label>Uploaded on</label>
              <input
                type="date"
                value={settings.uploaded_on}
                onChange={(e) => updateSetting("uploaded_on", e.target.value)}
              />
            </div>

            <div className="settings-field">
              <label>Area</label>
              <input type="text" value={settings.area} onChange={(e) => updateSetting("area", e.target.value)} />
            </div>
            <div className="settings-field">
              <label>Grades to Attend</label>
              <input
                type="text"
                value={settings.grade_attend}
                onChange={(e) => updateSetting("grade_attend", e.target.value)}
              />
            </div>

            <div className="settings-field">
              <label>Delivery Type</label>
              <select
                value={settings.delivery_type}
                onChange={(e) => updateSetting("delivery_type", e.target.value)}
              >
                <option value="" disabled hidden>Select</option>
                <option value="Self-paced">Self-paced</option>
                <option value="Instructor-led">Instructor-led</option>
                <option value="Blended">Blended</option>
              </select>
            </div>
            <div className="settings-field">
              <label>Delivery</label>
              <select value={settings.delivery} onChange={(e) => updateSetting("delivery", e.target.value)}>
                <option value="" disabled hidden>Select</option>
                <option value="Online">Online</option>
                <option value="Offline">Offline</option>
                <option value="Seminar">Seminar</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div>

            <div className="settings-field">
              <label>Access</label>
              <select value={settings.access} onChange={(e) => updateSetting("access", e.target.value)}>
                <option value="" disabled hidden>Select</option>
                <option value="Mandatory">Mandatory</option>
                <option value="Optional">Optional</option>
                <option value="Restricted">Restricted</option>
              </select>
            </div>
            <div className="settings-field checkbox-field">
              <input
                type="checkbox"
                id="cpd_certified"
                checked={settings.cpd_certified}
                onChange={(e) => updateSetting("cpd_certified", e.target.checked)}
              />
              <label htmlFor="cpd_certified">CPD Certified</label>
            </div>

            <div className="settings-field">
              <label>Country</label>
              <input
                type="text"
                value={settings.country}
                onChange={(e) => updateSetting("country", e.target.value)}
              />
            </div>
            <div className="settings-field">
              <label>Hours (Credits)</label>
              <input type="number" value={settings.hours} onChange={(e) => updateSetting("hours", e.target.value)} />
            </div>

            <div className="settings-field">
              <label>Certificate Level</label>
              <select
                value={settings.certificate_level}
                onChange={(e) => updateSetting("certificate_level", e.target.value)}
              >
                <option value="" disabled hidden>Select</option>
                <option value="Cert Basic">Cert Basic</option>
                <option value="Cert Intermediate">Cert Intermediate</option>
                <option value="Cert Final">Cert Final</option>
              </select>
            </div>
            <div className="settings-field">
              <label>CPD Hours</label>
              <input
                type="number"
                value={settings.cpd_hours}
                onChange={(e) => updateSetting("cpd_hours", e.target.value)}
              />
            </div>

            {/* Settings > Course > Custom Field definitions, rendered the
                same way People's custom fields are on the Add Person form.
                Dropdown choices now come from field.field_options (a
                JSON-stringified array defined in Settings > Course >
                Custom Field). */}
            {courseCustomFields.map((field) => {
              let dropdownChoices = [];
              if (field.type === "dropdown") {
                try {
                  const parsed = field.field_options
                    ? JSON.parse(field.field_options)
                    : [];
                  dropdownChoices = Array.isArray(parsed) ? parsed : [];
                } catch (error) {
                  dropdownChoices = [];
                }
              }

              // Checkbox fields use the same small green tick-box row as the
              // built-in "CPD Certified" / "Hide from Course List" fields.
              if (field.type === "checkbox") {
                const inputId = `custom_field_${field.field_id}`;
                return (
                  <div className="settings-field checkbox-field" key={field.field_id}>
                    <input
                      type="checkbox"
                      id={inputId}
                      // Saved values come back as text - "false" must stay unticked.
                      checked={
                        customFieldValues[field.field_id] === true ||
                        customFieldValues[field.field_id] === "true"
                      }
                      onChange={(e) =>
                        updateCustomFieldValue(field.field_id, e.target.checked)
                      }
                    />
                    <label htmlFor={inputId}>{field.field_name}</label>
                  </div>
                );
              }

              return (
                <div className="settings-field" key={field.field_id}>
                  <label>{field.field_name}</label>
                  {field.type === "date" ? (
                    <input
                      type="date"
                      value={customFieldValues[field.field_id] || ""}
                      onChange={(e) =>
                        updateCustomFieldValue(field.field_id, e.target.value)
                      }
                    />
                  ) : field.type === "dropdown" ? (
                    <select
                      value={customFieldValues[field.field_id] || ""}
                      onChange={(e) =>
                        updateCustomFieldValue(field.field_id, e.target.value)
                      }
                    >
                      <option value="" disabled hidden>Select</option>
                      {/* A field saved in Settings with no choices would
                          otherwise open to an empty list. */}
                      {dropdownChoices.length === 0 && (
                        <option value="__none" disabled>
                          No options available
                        </option>
                      )}
                      {dropdownChoices.map((choice) => (
                        <option key={choice} value={choice}>
                          {choice}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      value={customFieldValues[field.field_id] || ""}
                      onChange={(e) =>
                        updateCustomFieldValue(field.field_id, e.target.value)
                      }
                    />
                  )}
                </div>
              );
            })}
          </SettingsGrid>
        )}

        {settingsTab === "Availability" && (
          <SettingsGrid>
            <div className="settings-field">
              <label>Capacity</label>
              <input
                type="number"
                value={settings.capacity}
                onChange={(e) => updateSetting("capacity", e.target.value)}
              />
            </div>
            <div className="settings-field">
              <label>Department</label>
              <input
                type="text"
                value={settings.department}
                onChange={(e) => updateSetting("department", e.target.value)}
              />
            </div>

            <div className="settings-field full-width">
              <label>Location</label>
              <input
                type="text"
                placeholder="e.g. Chennai, Sydney, Nairobi"
                value={settings.location}
                onChange={(e) => updateSetting("location", e.target.value)}
              />
            </div>

            <div className="settings-field">
              <label>Start Date</label>
              <input
                type="date"
                value={settings.start_date}
                onChange={(e) => updateSetting("start_date", e.target.value)}
              />
            </div>
            <div className="settings-field">
              <label>Start Time</label>
              <input
                type="time"
                value={settings.start_time}
                onChange={(e) => updateSetting("start_time", e.target.value)}
              />
            </div>

            <div className="settings-field">
              <label>End Date</label>
              <input
                type="date"
                value={settings.end_date}
                onChange={(e) => updateSetting("end_date", e.target.value)}
              />
            </div>
            <div className="settings-field">
              <label>End Time</label>
              <input
                type="time"
                value={settings.end_time}
                onChange={(e) => updateSetting("end_time", e.target.value)}
              />
            </div>
          </SettingsGrid>
        )}

        {settingsTab === "Rules and Paths" && (
          <SettingsGrid>
            <div className="settings-field">
              <label>Show Units</label>
              <select value={settings.show_units} onChange={(e) => updateSetting("show_units", e.target.value)}>
                <option value="In any order">In any order</option>
                <option value="In sequential order">In sequential order</option>
              </select>
            </div>
            <div className="settings-field">
              <label>Course is completed when</label>
              <select
                value={settings.course_completed_when}
                onChange={(e) => updateSetting("course_completed_when", e.target.value)}
              >
                <option value="All the units are completed">All the units are completed</option>
                <option value="Any unit is completed">Any unit is completed</option>
                <option value="Manually marked complete">Manually marked complete</option>
              </select>
            </div>

            <div className="settings-field">
              <label>Calculate score by</label>
              <select
                value={settings.calculate_score_by}
                onChange={(e) => updateSetting("calculate_score_by", e.target.value)}
              >
                <option value="All tests and assignments">All tests and assignments</option>
                <option value="Highest score">Highest score</option>
                <option value="Most recent attempt">Most recent attempt</option>
              </select>
            </div>
          </SettingsGrid>
        )}

        {settingsTab === "Certificate" && (
          <SettingsGrid>
            <div className="settings-field full-width">
              <label>Offer Certificate</label>
              <div className="radio-row">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="offer_certificate"
                    checked={settings.offer_certificate === true}
                    onChange={() => updateSetting("offer_certificate", true)}
                  />
                  Yes
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="offer_certificate"
                    checked={settings.offer_certificate === false}
                    onChange={() => updateSetting("offer_certificate", false)}
                  />
                  No
                </label>
              </div>
            </div>
          </SettingsGrid>
        )}

        <div className="settings-footer">
          <button className="settings-cancel-btn" onClick={cancelSettings}>
            Cancel
          </button>
          <button className="settings-save-btn" onClick={saveSettings}>
            Save
          </button>
        </div>
      </CreateCourseWrap>
    );
  }

  return (
    <CreateCourseWrap>
      {/* Breadcrumb */}
      <div 
      style={{ display: "flex", alignItems: "center", gap: "07px" }} 
      className="breadcrumb">
        <Link to="/course">
          <span>Course</span>
        </Link>
        {/* <span className="separator"> &gt; </span> */}
        <img src={vectorimage} 
  style={{ width: "8px", height: "14px", margin: "0px 5px 0px 5px" }}
        alt=">" className="separator" />
        <span>{editingCourse ? "Editing Course" : "Creating Course"}</span>
      </div>
      <div className="course-header">
        <p className="user-menu-title">Course Details</p>
        <div className="course-header-actions">
          <button className="course-settings-link" onClick={openSettings}>
            <SettingOutlined /> Course Settings
          </button>
          <button
            className="publish-course-button"
            onClick={handlePublish}
            disabled={saving}
            style={{ cursor: saving ? "not-allowed" : "pointer" }}
          >
            {saving ? "Saving..." : editingCourse ? "Save Changes" : "Publish Course"}
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="content-wrapper">
        {/* Side Menu */}
        <div className="side-menu">
          <div className="add-units-select">
            <select
              key={units.length}
              ref={unitTypeSelectRef}
              defaultValue=""
              onChange={(e) => handleAddUnit(e.target.value)}
            >
              {/* Placeholder only - hidden so it isn't repeated as the
                  first item in the open list. */}
              <option value="" disabled hidden>
                Add Units
              </option>
              {UNIT_TYPES.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
            <DownOutlined className="add-units-chevron" />
          </div>
          {/* Separator Line */}
          <div className="separator-line"></div>
          <ul
          >
            <li
          style={{ backgroundColor: "#E2E2E9"}}  
              className={activeUnitId === null ? "unit-item active" : "unit-item"}
              onClick={() => setActiveUnitId(null)}
            >
              <span className="unit-item-label">Course Info</span>
            </li>
            {units.map((unit) => (
              <li
                key={unit.id}
                className={activeUnitId === unit.id ? "unit-item active" : "unit-item"}
                onClick={() => setActiveUnitId(unit.id)}
              >
                <span className="unit-item-label">{unit.title || unit.type}</span>
                {/* Figma: vertical three-dot menu with Rename / Duplicate / Delete. */}
                <Dropdown
                  trigger={["click"]}
                  placement="bottomLeft"
                  menu={{
                    items: unitMenuItems,
                    onClick: ({ key, domEvent }) => {
                      domEvent.stopPropagation();
                      handleUnitMenuClick(unit.id, key);
                    },
                  }}
                >
                  <button
                    type="button"
                    className="unit-item-menu"
                    aria-label={`${unit.title || unit.type} options`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <MoreOutlined />
                  </button>
                </Dropdown>
              </li>
            ))}
          </ul>
        </div>

        {/* Main Content */}
        <div className="course-details">
          {activeUnit ? (
            <>
              {activeUnit.type === "Content" && (
                <div>
                  <input
                    ref={unitTitleInputRef}
                    className="unit-title-input"
                    value={activeUnit.title}
                    onChange={(e) => updateUnitField(activeUnit.id, "title", e.target.value)}
                  />
                  <p className="field-label">Add detailed content</p>
                  <div className="rich-toolbar">
                    <MinusOutlined />
                    <span className="rt-size">14</span>
                    <PlusOutlined />
                    <span className="rt-b">B</span>
                    <span className="rt-u">U</span>
                    <span className="rt-i">I</span>
                    <OrderedListOutlined />
                    <UnorderedListOutlined />
                  </div>
                  <textarea
                    className="rich-textarea"
                    value={activeUnit.body}
                    onChange={(e) => updateUnitField(activeUnit.id, "body", e.target.value)}
                  />
                </div>
              )}

              {activeUnit.type === "Web content" && (
                <div>
                  <input
                    ref={unitTitleInputRef}
                    className="unit-title-input"
                    value={activeUnit.title}
                    onChange={(e) => updateUnitField(activeUnit.id, "title", e.target.value)}
                  />
                  <p className="field-label">Enter the URL of the web content</p>
                  <input
                    type="text"
                    placeholder="https://..."
                    value={activeUnit.url}
                    onChange={(e) => updateUnitField(activeUnit.id, "url", e.target.value)}
                  />
                  {activeUnit.url && (
                    <div className="web-content-preview">
                      <div className="preview-title">{activeUnit.title || "Web content preview"}</div>
                      <div className="preview-desc">
                        {activeUnit.description || "A preview of the linked page will appear here."}
                      </div>
                      <a href={activeUnit.url} target="_blank" rel="noreferrer">
                        View the content
                      </a>
                    </div>
                  )}
                </div>
              )}

              {activeUnit.type === "Video" && (
                <div>
                  <input
                    ref={unitTitleInputRef}
                    className="unit-title-input"
                    value={activeUnit.title}
                    onChange={(e) => updateUnitField(activeUnit.id, "title", e.target.value)}
                  />
                  <p className="field-label">Description (Optional)</p>
                  <textarea
                    value={activeUnit.description}
                    onChange={(e) => updateUnitField(activeUnit.id, "description", e.target.value)}
                  />
                  {!activeUnit.showMediaInput ? (
                    <div className="media-button-row">
                      <button className="media-choice-button" onClick={() => revealUnitMedia(activeUnit.id)}>
                        <YoutubeOutlined /> Add YouTube Video
                      </button>
                      <button
                        className="media-choice-button"
                        onClick={() => triggerFileUpload(activeUnit.id)}
                        disabled={uploadingUnitId === activeUnit.id}
                      >
                        <FileUploadIcon />
                        {uploadingUnitId === activeUnit.id ? "Uploading..." : "Upload Video"}
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div className="media-header">
                        <p className="field-label">
                          {isUploadedMedia(activeUnit) ? "Uploaded Video" : "Enter the URL of the web content"}
                        </p>
                        <button type="button" className="media-change" onClick={() => clearUnitMedia(activeUnit.id)}>
                          <EditOutlined /> Change
                        </button>
                      </div>
                      {isUploadedMedia(activeUnit) ? (
                        <div className="uploaded-file">
                          <FileTypeIcon name={fileNameFromUrl(activeUnit.mediaUrl)} />
                          <span className="uploaded-file-name">{fileNameFromUrl(activeUnit.mediaUrl)}</span>
                        </div>
                      ) : (
                        <input
                          type="text"
                          placeholder="https://youtube.com/..."
                          value={activeUnit.mediaUrl}
                          onChange={(e) => updateUnitField(activeUnit.id, "mediaUrl", e.target.value)}
                        />
                      )}
                      {activeUnit.mediaUrl && (
                        <div className="media-preview">
                          {getYouTubeEmbedUrl(activeUnit.mediaUrl) ? (
                            <iframe
                              width="560"
                              height="315"
                              src={getYouTubeEmbedUrl(activeUnit.mediaUrl)}
                              title="Video preview"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            />
                          ) : (
                            <video width="560" height="315" controls src={activeUnit.mediaUrl} />
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {activeUnit.type === "Audio" && (
                <div>
                  <input
                    ref={unitTitleInputRef}
                    className="unit-title-input"
                    value={activeUnit.title}
                    onChange={(e) => updateUnitField(activeUnit.id, "title", e.target.value)}
                  />
                  <p className="field-label">Description (Optional)</p>
                  <textarea
                    value={activeUnit.description}
                    onChange={(e) => updateUnitField(activeUnit.id, "description", e.target.value)}
                  />
                  {!activeUnit.showMediaInput ? (
                    <div className="media-button-row">
                      <button
                        className="media-choice-button"
                        onClick={() => triggerFileUpload(activeUnit.id)}
                        disabled={uploadingUnitId === activeUnit.id}
                      >
                        <FileUploadIcon />
                        {uploadingUnitId === activeUnit.id ? "Uploading..." : "Upload Audio"}
                      </button>
                    </div>
                  ) : (
                    <div style={{ marginTop: 16 }}>
                      <p className="field-label">Uploaded Audio</p>
                      <UploadedFileRow unit={activeUnit} onRemove={() => clearUnitMedia(activeUnit.id)} />
                      {activeUnit.mediaUrl && (
                        <div className="media-preview">
                          <audio controls src={activeUnit.mediaUrl} style={{ width: "100%" }} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {activeUnit.type === "Presentation / Document" && (
                <div>
                  <input
                    ref={unitTitleInputRef}
                    className="unit-title-input"
                    value={activeUnit.title}
                    onChange={(e) => updateUnitField(activeUnit.id, "title", e.target.value)}
                  />
                  <p className="field-label">Description (Optional)</p>
                  <textarea
                    value={activeUnit.description}
                    onChange={(e) => updateUnitField(activeUnit.id, "description", e.target.value)}
                  />
                  {!activeUnit.showMediaInput ? (
                    <div className="media-button-row">
                      <button
                        className="media-choice-button"
                        onClick={() => triggerFileUpload(activeUnit.id)}
                        disabled={uploadingUnitId === activeUnit.id}
                      >
                        <FileUploadIcon />
                        {uploadingUnitId === activeUnit.id ? "Uploading..." : "Upload File"}
                      </button>
                    </div>
                  ) : (
                    <div style={{ marginTop: 16 }}>
                      <p className="field-label">Uploaded File</p>
                      <UploadedFileRow unit={activeUnit} onRemove={() => clearUnitMedia(activeUnit.id)} />
                    </div>
                  )}
                </div>
              )}

              {!DESIGNED_UNIT_TYPES.includes(activeUnit.type) && (
                <div>
                  <input
                    ref={unitTitleInputRef}
                    className="unit-title-input"
                    value={activeUnit.title}
                    onChange={(e) => updateUnitField(activeUnit.id, "title", e.target.value)}
                  />
                  <p className="field-label">Description (Optional)</p>
                  <textarea
                    value={activeUnit.description}
                    onChange={(e) => updateUnitField(activeUnit.id, "description", e.target.value)}
                  />
                </div>
              )}
            </>
          ) : (
            <div>
              <div className="course-header-box">
                <input
                  type="text"
                  placeholder="Enter the course name"
                  value={courseName}
                  onChange={(e) => setCourseName(e.target.value)}
                />

                <div
                  className={`upload-section${courseProfileUrl ? " has-image" : ""}${uploadingProfile ? " is-uploading" : ""}`}
                  onClick={() => profileFileInputRef.current?.click()}
                >
                  {courseProfileUrl && (
                    <img className="upload-section-image" src={courseProfileUrl} alt="Course profile" />
                  )}
                  <div className="upload-section-label">
                    <UploadOutlined style={{ fontSize: 24, color: courseProfileUrl ? "#fff" : "#636980" }} />
                    <span>
                      {uploadingProfile
                        ? "Uploading..."
                        : courseProfileUrl
                        ? "Change Course Profile"
                        : "Upload Course Profile"}
                    </span>
                  </div>
                </div>
                <input
                  type="file"
                  ref={profileFileInputRef}
                  style={{ display: "none" }}
                  onChange={handleProfileFileSelected}
                  accept="image/*"
                />
              </div>

              <div className="description-section">
                <p className="field-label">Description</p>
                <textarea
                  placeholder="A dedicated group for aspiring and professional designers alike. Dive into topics ranging from visual design principles to advanced prototyping, participate in hands-on projects, and learn from peer feedback. Enhance your portfolio while building connections with other designers."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              {/* Add Units Button - lives inside course-details so it's
                  centered under the course card, not under the whole page
                  (which used to include the side-menu column and pushed it
                  visibly off-center from the card above it). */}
              {units.length === 0 && (
                <div className="add-units-container">
                  <button
                    onClick={() => unitTypeSelectRef.current?.focus()}
                    className="add-units-button"
                    aria-label="Add units"
                  >
                    <PlusOutlined />
                  </button>
                  <div>Add Units to Publish the Course</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileSelected}
        accept="video/*,audio/*,.pdf,.doc,.docx,.ppt,.pptx"
      />

      <Modal open={publishedVisible} footer={null} centered closable={false} width={198}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
          <Tick style={{ width: "34px", height: "34px" }} />
          <p style={{ fontSize: "16px", fontWeight: 400, margin: "8px 0 0" }}>
            {editingCourse ? "Saved" : "Published"}
          </p>
        </div>
      </Modal>
    </CreateCourseWrap>
  );
};

export default CreateCourse;
